export const BOOKMARK_NAME = "_aiEditTarget";

export const bookmarkSelection = async (
  context: Word.RequestContext
): Promise<void> => {
  try {
    const selection = context.document.getSelection();
    try {
      context.document.deleteBookmark(BOOKMARK_NAME);
      await context.sync();
    } catch {
      // Ignore if bookmark doesn't exist yet.
    }

    selection.insertBookmark(BOOKMARK_NAME);
    await context.sync();
  } catch (err) {
    console.warn("[AIEdit] Could not bookmark selection:", err);
  }
};

export const getBookmarkedRange = async (
  context: Word.RequestContext
): Promise<Word.Range> => {
  try {
    const range = context.document.getBookmarkRangeOrNullObject(BOOKMARK_NAME);
    await context.sync();
    if (!range.isNullObject) return range;
  } catch {
    console.warn("[AIEdit] Bookmark not found, falling back to current selection");
  }

  return context.document.getSelection();
};

export const cleanupBookmark = async (): Promise<void> => {
  try {
    await Word.run(async (context) => {
      context.document.deleteBookmark(BOOKMARK_NAME);
      await context.sync();
    });
  } catch {
    // Non-critical cleanup.
  }
};

/** Use inside an already-open Word.run to avoid a second round-trip. */
export const cleanupBookmarkInContext = async (
  context: Word.RequestContext
): Promise<void> => {
  try {
    context.document.deleteBookmark(BOOKMARK_NAME);
    await context.sync();
  } catch {
    // Non-critical.
  }
};
